const ANALYTICS_CHANNEL = 'peopleTeams';
const runItLater = cb => {
  if (window.requestIdleCallback === 'function') {
    return window.requestIdleCallback(cb);
  }
  if (typeof window.requestAnimationFrame === 'function') {
    return window.requestAnimationFrame(cb);
  }
  return () => setTimeout(cb);
};
const fireEvent = kind => (createAnalyticsEvent, body) => {
  if (!createAnalyticsEvent) {
    return;
  }
  runItLater(() => {
    createAnalyticsEvent({
      eventType: kind,
      ...body
    }).fire(ANALYTICS_CHANNEL);
  });
};
export const fireOperationalEvent = fireEvent('operational');
export const fireScreenEvent = fireEvent('screen');
export const fireTrackEvent = fireEvent('track');
export const fireUIEvent = fireEvent('ui');
export const isSeriousError = error => {
  if (!error) {
    return false;
  }

  // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
  if ('status' in error && error['status'] === 403 || error.message.includes(' 403')) {
    return false;
  }
  if ('status' in error && error['status'] === 401 || error.message.includes(' 401')) {
    return false;
  }
  if ('status' in error && error['status'] === 429 || error.message.includes(' 429')) {
    return false;
  }
  if (error.message === 'Failed to fetch') {
    return false;
  }
  return true;
};